<div class="toolbar-panel bg-grey-0 radius-12 is-flex is-column gap-4">
  <ng-content />
</div>